import React, { Fragment, useState } from 'react';
import { getAuth } from '../globals/authentication';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import BuildIcon from '@mui/icons-material/Build';
// import DeleteIcon from "@mui/icons-material/Delete";
import {
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Grid,
  Drawer,
  Divider,
  Box,
} from '@mui/material';
import { isLoggedIn, logout } from '../globals/utils';
import { useNavigate } from 'react-router-dom';
import SendIcon from '@mui/icons-material/Send';
import GroupsIcon from '@mui/icons-material/Groups';
import FactoryIcon from '@mui/icons-material/Factory';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import InventoryIcon from '@mui/icons-material/Inventory';
import ExtensionIcon from '@mui/icons-material/Extension';
import LogoutIcon from '@mui/icons-material/Logout';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import LanguageChange from './LanguageTranslationPopup';
import { HOME_PAGE } from '../globals/const';
import PeopleIcon from '@mui/icons-material/People';
import LanguageIcon from '../assets/Icon/LangaugeIcon.svg';
import NotificationIcon from '../assets/Icon/NotificationIcon.png';
import LogoutConfirmationDialog from './LogoutConfirmation';
import { useTranslation } from 'react-i18next';
import {
  AccountBalance,
  CorporateFare,
  Grass,
  Home,
  Person,
  Map,
  SupportAgent,
  SpaceDashboard,
  Campaign,
} from '@mui/icons-material';
import LockResetIcon from '@mui/icons-material/LockReset';
import LockIcon from '@mui/icons-material/Lock';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import MenuItemLogo from '../assets/logo/FarmAppLogo.png';
import DeleteAccountDialog from './Custom/DeleteAccountDialog';
import InternalLoginSubHeader from './InternalLoginSubHeader';

export default function CustomAppBar({ isProtected = true }) {
  const auth = getAuth();
  const { role } = auth;
  const classes = {};
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false);
  const [showAccountDeleteDialog, setShowAccountDeleteDialog] = useState(false);
  const [languagePopup, setLanguagePopup] = useState(false);
  const { t } = useTranslation();

  // Uncomment the following function if you want to enable delete functionality
  // const handleOpenDeleteAccountDialog = () => {
  //   setShowAccountDeleteDialog(true);
  // };

  const handleCloseAccountDeleteDialog = () => {
    setShowAccountDeleteDialog(false);
  };

  if (!isLoggedIn() && isProtected) {
    navigate('/login');
    return;
  }

  const farmerNavigationItems = [
    {
      text: t('Home'),
      icon: <Home />,
      path: '/',
    },
    {
      text: t('Profile'),
      icon: <Person />,
      path: '/farmer/profile',
    },
  ];

  const fpoNavigationItems = [
    {
      text: t('Home'),
      icon: <CorporateFare />,
      path: '/fpo/profile',
    },
    {
      text: t('My Farmers'),
      icon: <GroupsIcon />,
      path: '/fpo/farmers',
    },
    {
      text: t('Loans'),
      icon: <AccountBalance />,
      path: '/fpo/loans',
    },
  ];
  const fpoAggregatorItem = [
    {
      text: t('Dashboard'),
      icon: <WarehouseIcon />,
      path: '/',
    },
    {
      text: t('My FPOS'),
      icon: <PeopleIcon />,
      path: '#',
    },
    {
      text: t('My Programs'),
      icon: <BuildIcon />,
      path: '/programs/',
    },
  ];
  const LenderNavigationItem = [
    {
      text: t('Home'),
      icon: <Home />,
      path: '/',
    },
    { text: t('Profile'), icon: <Person />, path: '/lender/profile' },
  ];
  const SponsorNavigationItem = [
    {
      text: t('Home'),
      icon: <Home />,
      path: '/',
    },
  ];
  const AdminNavigationItem = [
    {
      text: t('Overview'),
      icon: <SpaceDashboard />,
      path: '/',
    },
    {
      text: t('Farmer Details'),
      icon: <Person />,
      path: '/admin/farmers',
    },
    {
      text: t('Farms Overview'),
      icon: <Map />,
      path: '/admin/farms-overview',
    },
    // {
    //   text: t("Biochar Forms"),
    //   icon: <AssignmentOutlined />,
    //   path: "/admin/biochar-forms",
    // },
    {
      text: t('Reset Passwords'),
      icon: <LockResetIcon />,
      path: '/reset-password-users',
    },
    {
      text: t('Announcement'),
      icon: <Campaign />,
      path: '/admin/announcement',
    },
  ];
  const CentralAdminNavigationItem = [
    {
      text: t('Overview'),
      icon: <SpaceDashboard />,
      path: '/',
    },
    {
      text: t('Farmer Details'),
      icon: <Person />,
      path: '/admin/farmers',
    },
    {
      text: t('Farms Overview'),
      icon: <Map />,
      path: '/admin/farms-overview',
    },
    {
      text: t('Campaigns'),
      icon: <Home />,
      path: '/admin/campaigns',
    },
    {
      text: t('Biochar'),
      icon: <Grass />,
      path: '/admin/biochar',
    },
    {
      text: t('Payments'),
      icon: <CurrencyRupeeIcon />,
      path: '/payments',
    },
    {
      text: t('Reset Passwords'),
      icon: <LockResetIcon />,
      path: '/reset-password-users',
    },
  ];

  const PlantInchargeNavigationItems = [
    {
      text: t('Home'),
      icon: <Home />,
      path: '/',
    },
  ];

  const handleLanuagePupup = () => {
    setLanguagePopup(true);
  };

  const NavigationList = ({ navigationItems, fill }) => {
    return navigationItems.map((item, index) => (
      <ListItemButton
        key={index}
        onClick={() => {
          navigate(item.path);
          setDrawerOpen(false);
        }}
      >
        <ListItemIcon>
          {React.cloneElement(item.icon, { style: { fill: fill } })}
        </ListItemIcon>
        <ListItemText primary={item.text} />
      </ListItemButton>
    ));
  };

  const rolePermissions = {
    FARMER: (
      <NavigationList navigationItems={farmerNavigationItems} fill="#4CAF50" />
    ),
    FPO: <NavigationList navigationItems={fpoNavigationItems} fill="#4CAF50" />,
    FPO_AGGREGATOR: (
      <NavigationList navigationItems={fpoAggregatorItem} fill="#4CAF50" />
    ),
    LENDER: (
      <NavigationList navigationItems={LenderNavigationItem} fill="#4CAF50" />
    ),
    SPONSOR: (
      <NavigationList navigationItems={SponsorNavigationItem} fill="#4CAF50" />
    ),
    AUDITOR: [
      <ListItemButton
        key="auditor-my-tasks"
        onClick={() => {
          window.open(HOME_PAGE + '/', '_self');
          setDrawerOpen(false);
        }}
      >
        <ListItemIcon>
          <ExtensionIcon />
        </ListItemIcon>
        <ListItemText primary={t('My Tasks')} />
      </ListItemButton>,
    ],
    TRANSPORTER: [
      <ListItemButton
        key="transport"
        onClick={() => {
          navigate(HOME_PAGE + '/transport/empty');
          setDrawerOpen(false);
        }}
      >
        <ListItemIcon>
          <SendIcon />
        </ListItemIcon>
        <ListItemText primary={t('Transport')} />
      </ListItemButton>,
    ],
    PROCESSOR: [
      <ListItemButton
        key="processor"
        onClick={() => {
          window.open(HOME_PAGE + '/processing-plants', '_self');
          setDrawerOpen(false);
        }}
      >
        <ListItemIcon>
          <FactoryIcon />
        </ListItemIcon>
        <ListItemText primary={t('My Processing Plants')} />
      </ListItemButton>,
      <ListItemButton
        key="product-recipies"
        onClick={() => {
          window.open(HOME_PAGE + '/product-recipes', '_self');
          setDrawerOpen(false);
        }}
      >
        <ListItemIcon>
          <ExtensionIcon />
        </ListItemIcon>
        <ListItemText primary={t('Product Recipes')} />
      </ListItemButton>,
      <ListItemButton
        key="create-batch"
        onClick={() => {
          window.open(HOME_PAGE + '/batches', '_self');
          setDrawerOpen(false);
        }}
      >
        <ListItemIcon>
          <FactoryIcon />
        </ListItemIcon>
        <ListItemText primary={t('Create Batch')} />
      </ListItemButton>,
    ],
    STORAGE: [
      <ListItemButton
        key="my-warehouses"
        onClick={() => {
          window.open(HOME_PAGE + '/warehouses', '_self');
          setDrawerOpen(false);
        }}
      >
        <ListItemIcon>
          <WarehouseIcon />
        </ListItemIcon>
        <ListItemText primary={t('My Warehouses')} />
      </ListItemButton>,
      <ListItemButton
        key="storage"
        onClick={() => {
          window.open(HOME_PAGE + '/storage', '_self');
          setDrawerOpen(false);
        }}
      >
        <ListItemIcon>
          <InventoryIcon />
        </ListItemIcon>
        <ListItemText primary={t('Storage')} />
      </ListItemButton>,
    ],
    ADMIN: (
      <NavigationList navigationItems={AdminNavigationItem} fill="#4CAF50" />
    ),
    CA: (
      <NavigationList
        navigationItems={CentralAdminNavigationItem}
        fill="#4CAF50"
      />
    ),
    PLANT_INCHARGE: (
      <NavigationList
        navigationItems={PlantInchargeNavigationItems}
        fill="#4CAF50"
      />
    ),
  };
  const handleBackButton = () => {
    if (location.pathname === '/') {
      setShowLogoutConfirmation(true);
    } else {
      navigate(-1);
    }
  };
  const handleLogoutConfirmation = () => {
    setShowLogoutConfirmation(false);
    logout();
  };

  const handleClickLogo = () => {
    navigate('/');
    setDrawerOpen(false);
  };
  return (
    <div className={classes.root}>
      <Fragment>
        <AppBar
          position="sticky"
          style={{
            backgroundColor: '#FFFFFF',
            borderBottom: '1px solid #ccc',
            boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
          }}
        >
          <Toolbar>
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="menu"
              onClick={setDrawerOpen}
            >
              <MenuIcon />
            </IconButton>
            <IconButton
              edge="start"
              sx={{ mx: '0.8rem' }}
              className={classes.menuButton}
              aria-label="back"
              // onClick={() => navigate(-1)}
              onClick={handleBackButton}
            >
              <ArrowBackIosIcon fontSize="10px" />
            </IconButton>

            <Grid container alignItems={'baseline'}>
              <Grid item xs={8}></Grid>
              <Grid item xs={2}>
                <IconButton
                  edge="end"
                  color="inherit"
                  aria-label="menu"
                  onClick={handleLanuagePupup}
                >
                  <img
                    src={LanguageIcon}
                    alt="langaugeChange"
                    style={{ width: '23px' }}
                  />
                </IconButton>
              </Grid>
              <Grid item xs={2}>
                <IconButton
                  edge="end"
                  color="inherit"
                  aria-label="menu"
                  onClick={() => {
                    alert('No current notifications'); // TODO: Implement notifications screen
                  }}
                >
                  <img src={NotificationIcon} style={{ width: '30px' }} />
                </IconButton>
              </Grid>
            </Grid>
            <LanguageChange
              open={languagePopup}
              onClose={() => setLanguagePopup(false)}
            />
          </Toolbar>
        </AppBar>

        {auth?.is_internal_login && <InternalLoginSubHeader auth={auth} />}

        <Drawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          classes={{ paper: classes.drawerPaper }}
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '20px 30px',
              }}
            >
              <img
                src={MenuItemLogo}
                style={{
                  width: 200,
                  height: 'auto',
                  cursor: 'pointer',
                }}
                onClick={handleClickLogo}
              />
            </Box>
            <List sx={{ flexGrow: 1 }}>
              {rolePermissions[role]}
              <Divider />
              <ListItemButton
                button
                onClick={() => navigate('/update-password')}
              >
                <ListItemIcon>
                  <LockIcon style={{ fill: '#4CAF50' }} />
                </ListItemIcon>
                <ListItemText primary={t('Update password')} />
              </ListItemButton>
              {/* <ListItemButton button onClick={handleOpenDeleteAccountDialog}>
                <ListItemIcon>
                  <DeleteIcon style={{ fill: "#4CAF50" }} />
                </ListItemIcon>
                <ListItemText primary={t("Delete Account")} />
              </ListItemButton> */}
              <ListItemButton
                button
                onClick={() => {
                  navigate('/support-chat');
                  setDrawerOpen(false);
                }}
              >
                <ListItemIcon>
                  <SupportAgent style={{ fill: '#4CAF50' }} />
                </ListItemIcon>
                <ListItemText primary={t('AI Agriculture')} />
              </ListItemButton>

              <ListItemButton
                button
                onClick={() => {
                  setDrawerOpen(false);
                  handleLanuagePupup();
                }}
              >
                <ListItemIcon>
                  <img
                    src={LanguageIcon}
                    alt="langaugeChange"
                    style={{ width: '23px' }}
                  />
                </ListItemIcon>
                <ListItemText primary={t('Select Langauge')} />
                <LanguageChange
                  open={languagePopup}
                  onClose={() => setLanguagePopup(false)}
                />
              </ListItemButton>

              <ListItemButton
                button
                onClick={() => {
                  logout();
                }}
              >
                <ListItemIcon>
                  <LogoutIcon style={{ fill: '#4CAF50' }} />
                </ListItemIcon>
                <ListItemText primary={t('Logout')} />
              </ListItemButton>
            </List>
          </Box>
        </Drawer>
      </Fragment>
      <LogoutConfirmationDialog
        open={showLogoutConfirmation}
        onClose={() => setShowLogoutConfirmation(false)}
        onConfirm={handleLogoutConfirmation}
      />
      <DeleteAccountDialog
        open={showAccountDeleteDialog}
        onClose={handleCloseAccountDeleteDialog}
      />
    </div>
  );
}
